import React from 'react'
import * as Sentry from '@sentry/react'
import { ErrorBoundary } from 'react-error-boundary'

const ErrorBoundarySentryWrapper = (props) => {
  const next = props.onError
  const handleError = (error, componentStack) => {
    Sentry.captureException(error)
    if (next && typeof next === 'function') {
      next(error, componentStack)
    }
  }
  return (
    <ErrorBoundary {...props} onError={handleError}>
      {props.children}
    </ErrorBoundary>
  )
}

export default ErrorBoundarySentryWrapper
